/**
 * Hand-picked story-circle avatars (uploaded to Supabase storage,
 * metadata-stripped 512px WebP). Characters not in this map fall back to
 * their regular avatar in the stories row.
 */
const BASE =
  'https://bjhhccyzlmjpgurefeef.supabase.co/storage/v1/object/public/character-media/story-avatars';

export const STORY_AVATARS: Record<string, string> = {
  'aurora-thatcher': `${BASE}/aurora-thatcher.webp`,
  'bianca-costa': `${BASE}/bianca-costa.webp`,
  'freya-lindqvist': `${BASE}/freya-lindqvist.webp`,
  'margot-laurent': `${BASE}/margot-laurent.webp`,
  'mei-lin': `${BASE}/mei-lin.webp`,
  'mia-rossi': `${BASE}/mia-rossi.webp`,
  'valeria-popescu': `${BASE}/valeria-popescu.webp`,
};
